import { render, staticRenderFns } from "./MetricsList.vue?vue&type=template&id=684c0fbb&scoped=true"
import script from "./MetricsList.vue?vue&type=script&lang=js"
export * from "./MetricsList.vue?vue&type=script&lang=js"
import style0 from "./MetricsList.vue?vue&type=style&index=0&id=684c0fbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684c0fbb",
  null
  
)

export default component.exports